import axios from "axios";
import Swal from "sweetalert2";
import { getSessionStorageValue } from "./getInfoSignatory";

export const getInfoAuth = async () => {
  const url = process.env.REACT_APP_API_BASEURL;
  const urlID = window.location.search;
  const urlParams = new URLSearchParams(urlID);
  const id = urlParams.get("id");

  const token = getSessionStorageValue("token_app");

  let config = {
    method: "get",
    maxBodyLength: Infinity,
    url: `${url}/request-signature/${id}/sign`,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const response = await axios.request(config);
    return response.data;
  } catch (error: any) {
    const errorMessage = error.response.data?.message
      || error.response.data?.errors?.error
      || 'Tente novamente';

    Swal.fire({
      title: "Atenção!",
      text: errorMessage,
      icon: "error",
      confirmButtonText: "OK",
      confirmButtonColor: "#355B94",
    });
  }
};
